<app-filter-debtor-black-list
    (geFilter)="receiveFilterGeneral($event)"
></app-filter-debtor-black-list>

<main>
    <app-table-debtor-black-list
        [recieveFilterName]="deudores"
        [booleanFlag]="booleanFlag"
        [booleanText]="booleanText"
        (changePagination)="receiveProviderPaginationChange($event)"
        (changeSorting)="receiveChangeSortingOrder($event)"
        (actualizarData)="actualizarData($event)"
    ></app-table-debtor-black-list>
</main>